<backdrop-container>
  <regular-popup [id]="id"
                 title="Contact Fagerhult"
                 [showHeader]="false"
                 [showFooter]="true"
                 [closeOnOk]="false"
                 height="90%"
                 width="700px"
                 (okClick)="okClick()"
                 okButtonText="Send"
                 [cancelButtonText]="strings.Cancel">

    <div card-type="body" class="p-4">
      <div>
        <text-box [view]="nameView" [errors]="nameErrors" (onValueChange)="valueChange($event)"></text-box>
        <text-box [view]="emailView" [errors]="emailErrors" (onValueChange)="valueChange($event)" type="email" autocomplete="email"></text-box>
        <text-box [view]="companyView" [errors]="companyErrors" (onValueChange)="valueChange($event)"></text-box>
        <text-box [view]="cityView"></text-box>
        <check-box [view]="phoneCheckedView" [triState]="false" (onValueChange)="contactByPhone($event)"></check-box>
        <text-box *ngIf="showPhone" [view]="phoneView"></text-box>
        <text-box [view]="messageView" rows="5"></text-box>
      </div>
    </div>
  </regular-popup>
</backdrop-container>